import React, {useContext} from 'react'

export type ReportsSpreadsheetRowContextProps = {
  data: any
  index: number
  prefix: string
}

const ReportsSpreadsheetRowContext = React.createContext<ReportsSpreadsheetRowContextProps>(
  null as any
)

export default ReportsSpreadsheetRowContext

export function useReportsSpreadsheetRowContext() {
  return useContext(ReportsSpreadsheetRowContext)
}
